import Skeleton from '@mui/material/Skeleton';

export const MerchantsShowActionSkeleton: React.FC = () => (
  <Skeleton height={36} variant="rounded" width={133} />
);
